import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import TextImageBlock from "@/common/partials/textImageBlock/textImageBlock"
import classNames from "classnames/bind"
import styles from "./content-block.module.css"

export default function ContentBlock({ block, settings }) {
  const { attrs, innerBlocks } = block
  const cx = classNames.bind(styles)

  if (innerBlocks === undefined || innerBlocks.length === 0) {
    return null
  }

  const blockSettings = {
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" }
  }

  if (settings?.multiple) {
    const classes = {
      wrapper: true,
      "theme-good-green": block.attrs.theme === "good-green",
      "theme-good-blue": block.attrs.theme === "good-blue"
    }

    return (
      <Block block={block} width="bleed" className={cx(classes)}>
        <div className="inner-wrapper">
          <Blocks blocks={innerBlocks} settings={blockSettings} />
        </div>
      </Block>
    )
  }

  return (
    <TextImageBlock
      block={block}
      layout={attrs.layout}
      image={attrs.image}
      plateColor={attrs.theme}
      padding={attrs.theme !== "transparent"}>
      <Blocks blocks={innerBlocks} settings={blockSettings} />
    </TextImageBlock>
  )
}
